import styled from 'styled-components';
import { LINE_HEIGHT, SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';

export const StyledRepoText = styled.div`
  font-size: ${SIZES.large};
  color: ${getColor('shuttleGray')};
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 30rem;
  line-height: ${LINE_HEIGHT.large};
`;
